import axios from 'axios'
import store from '@/store'

function saveQuendaTurn(turnId, token, client, storeId, name, phone) {
  try {
    let url = `${process.env.VUE_APP_PATH}saveQuendaTurn`
    axios.post(url, {
      turnId: turnId,
      turnCode: turnId,
      token: token,
      client: client,
      storeId: storeId,
      sessionId: store.state.session.sessionId,
      name: name,
      phone: phone
    })
  } catch (err) {
    console.log(err)
  }
}

export default saveQuendaTurn
